import AdminSimpleManager from "./AdminSimpleManager";

const fields = [
  { name: "customer_name", label: "Customer name" },
  { name: "role", label: "Role" },
  { name: "review_text", label: "Review text", type: "textarea" },
  { name: "rating", label: "Rating", type: "number" },
  { name: "sort_order", label: "Sort order", type: "number" },
  { name: "active", label: "Active", type: "checkbox" },
];

export default function AdminTestimonials() {
  return (
    <AdminSimpleManager
      title="Testimonials"
      eyebrow="Social proof"
      endpoint="/api/testimonials"
      fields={fields}
      emptyItem={{ customer_name: "", role: "", review_text: "", rating: 5, sort_order: 0, active: true }}
      labelField="customer_name"
    />
  );
}
